import dayjs from "dayjs";

type GetUnifiedCheckoutDeliveryDatesParameters = {
  deliveryPreference: "consolidated" | "split" | null | undefined;
  consolidatedDeliveryDate: string | Date | null | undefined;
  supplierDeliveryDates: Array<string | Date | null | undefined>;
};

export const getUnifiedCheckoutDeliveryDates = ({
  deliveryPreference,
  consolidatedDeliveryDate,
  supplierDeliveryDates,
}: GetUnifiedCheckoutDeliveryDatesParameters) => {
  const dates =
    deliveryPreference === "split"
      ? supplierDeliveryDates
      : [consolidatedDeliveryDate];
  const validDates = dates
    .filter((date): date is string | Date => Boolean(date))
    .map((date) => dayjs(date))
    .filter((date) => date.isValid())
    .sort((first, second) => first.valueOf() - second.valueOf());

  return [...new Set(validDates.map((date) => date.format("YYYY-MM-DD")))];
};
